// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1Yvgv","label":"Category_label__zqEUe","content":"Category_content__1rYu8","header":"Category_header__1zg9p","location":"Category_location__XI9BC"};